import { SdkError, ERROR_CODES } from "@signaloid/cloud-compute-engine-client";

import { UserLimitsE, type UserLimits } from "@/js/tierconfig";

export function extractSdkErrorMessage(error: unknown): string {
	if (!(error instanceof SdkError)) {
		return "";
	}

	const body = error.details as { message?: unknown; Message?: unknown } | undefined;
	const message = body?.message ?? body?.Message;
	return typeof message === "string" ? message : "";
}

export function tierLimitFromSdkError(error: unknown, concurrencyLimit: UserLimits): undefined | UserLimits {
	if (!(error instanceof SdkError)) {
		return undefined;
	}

	switch (error.errorType) {
		case "ExecutionTimeLimitExceeded":
			return UserLimitsE.ExecutionTimeInMillisecondsCount;
		case "ConcurrencyLimitExceeded":
			return concurrencyLimit;
	}

	return error.code === ERROR_CODES.API_FORBIDDEN ? concurrencyLimit : undefined;
}

const REALTIME_GIVE_UP_AUTH_CODES: readonly string[] = [
	ERROR_CODES.AUTH_MISSING_TOKEN,
	ERROR_CODES.AUTH_INVALID_TOKEN,
	ERROR_CODES.AUTH_NOT_LOGGED_IN,
	ERROR_CODES.AUTH_UNSUPPORTED_METHOD,
	ERROR_CODES.WS_UNAUTHORIZED,
];

function isPermanentRealtimeAuthError(error: unknown): boolean {
	if (!(error instanceof SdkError)) {
		return false;
	}
	if (REALTIME_GIVE_UP_AUTH_CODES.includes(error.code)) {
		return true;
	}
	return error.code === ERROR_CODES.AUTH_FAILED && isPermanentRealtimeAuthError(error.details);
}

export function isRealtimeGiveUpError(error: unknown): boolean {
	if (!(error instanceof SdkError)) {
		return false;
	}
	return error.code === ERROR_CODES.REALTIME_CONNECTION_FAILED || isPermanentRealtimeAuthError(error);
}
